import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AttemptService {
  private wrongAttemptSubject = new BehaviorSubject<string>('');
  wrongAttempt$ = this.wrongAttemptSubject.asObservable();

  setWrongAttempt(value: string) {
    this.wrongAttemptSubject.next(value); // Notify all subscribers
  }

  clearWrongAttempt() {
    this.wrongAttemptSubject.next('');
  }
}
